import React, { useState, useEffect } from "react";
import {
  Breadcrumb,
  Steps,
  message,
  notification,
  Button,
  Form,
  Spin,
  Notification,
} from "antd";
import { HomeOutlined } from "@ant-design/icons";
import { isEmpty, get, range, uniqBy, compact, orderBy, flatten } from "lodash";
import Cookies from "js-cookie";
import TargetUsers from "./target-user";
import EmailCompaign from "./Email/index";
import ScheduleCampaign from "./schedule-campaign";
import PushCampaign from "./Push/index";
import SmsCampaign from "./SMS";
import API from "../utils/Api";
import {
  finalValues,
  targetUser,
  ScheduleFields,
} from "../shared/camp-constant-values";
import {
  fieldValuesCheck,
  throwErrors,
  getApiUrl,
  getWalletBalance,
} from "../shared/camp-helper";
import WhatsappCampaign from "./Whatsapp";

const { Step } = Steps;

const CampaignTab = (properties) => {
  const { history } = properties;
  const myApi = new API({});
  myApi.createEntity({ name: "campaign" });
  myApi.createEntity({ name: "broadCast" });
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [appID] = useState(Cookies.get("appID"));
  const [apiUrl] = useState(Cookies.get("apiUrl"));
  const [appName] = useState(Cookies.get("camp_appName"));
  const [appKey] = useState(Cookies.get("appKey"));
  const tenantId = Cookies.get("tenant_id") || "";
  const [stepsValue, setStepsValue] = useState(0);
  const [selectCampaign, setSelectCampaign] = useState("");
  const [excelData, setExcelData] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [customValidate, setCustomValidate] = useState("success");
  const [validateMessage, setValidateMessage] = useState("");
  const [templateExpressionCount, setTemplateExpressionCount] = useState(0);
  const [users, setUsers] = useState([]);
  const [whatsappTemplateData, setWhatsappTemplateData] = useState([]);
  const [dupTemplateObj, setDupTemplateObj] = useState({});
  const [dupWtTemp, setDupWtTemp] = useState("");
  const [costing, setCosting] = useState(0);
  const [broadCast, setBroadCast] = useState([]);
  const paymentType = form.getFieldValue("payment_type");
  const whatsappTemplate = form.getFieldValue("whatsappTemplate");
  const [selectedUser, setSelectedUser] = useState(0);
  const [walletBalance, setWalletBalance] = useState(0);
  const [walletBalanceError, setWalletBalanceError] = useState("");

  const updateStepsValue = ({ onlyValidation }) => {
    if (!onlyValidation) {
      setStepsValue(stepsValue + 1);
    }
  };
  const getExpressionCount = (value) => {
    setTemplateExpressionCount(value);
  };
  useEffect(() => {
    fetchUser();
    fetchWalletBalance();
  }, []);

  const fetchUser = () => {
    const fields = {
      params: {
        apiUrl: apiUrl,
      },
    };
    const fieldBroadCast = {
      params: {
        campKey: appKey,
      },
    };
    const apiArray = [
      myApi.endpoints.campaign.getAll(fields, {}, "get-all-user"),
      myApi.endpoints.campaign.getAll(fields, {}, "get-costing"),
      myApi.endpoints.broadCast.getAll(fieldBroadCast, {}, "get-all"),
    ];
    Promise.all(apiArray)
      .then((res) => {
        const userData = uniqBy(res[0].data.userData, "phone_number");
        const orderUserData = orderBy(userData, ["user_name"], ["asc"]);
        const getCosting = get(res[1], "data.data", {});
        const getBroadCast = get(res[2], "data.data", {});
        setCosting(get(getCosting, "value", 0));
        setUsers(orderUserData);
        setBroadCast(getBroadCast);
      })
      .catch((error) => {
        Notification.error(error.message || "Failed to Fetch data");
      });
  };
  const fetchWalletBalance = async () => {
    const data = {
      apiUrl,
      filterName: "settings",
    };
    const api_url = await getApiUrl(data);
    const params = {
      user_id: tenantId,
    };
    getWalletBalance(params, api_url[0])
      .then((response) => {
        const data = get(response, "data.data");
        setWalletBalance(data.wallet_balance);
        if (data?.wallet_balance <= 0) {
          setWalletBalanceError(
            "Low Balance. Please Recharge your wallet and try."
          );
        }
      })
      .catch((error) => {
        Notification.error(error.message || "Failed to Fetch data");
      });
  };

  useEffect(() => {
    setLoading(true);
    const fields = {
      params: {
        apiUrl: "",
      },
    };
    myApi.endpoints.campaign
      .getAll(fields, {}, "get-whatsapp-template")
      .then((res) => {
        setLoading(false);
        setWhatsappTemplateData(res.data.data);
      })
      .catch((error) => {
        setLoading(false);
        notification.error({ message: error || "failed to send message" });
      });
  }, []);

  const next = ({ onlyValidation }) => {
    if (stepsValue === 0) {
      if (!isEmpty(excelData) && fileList.length) {
        const errData = [];
        if (
          !excelData[0].hasOwnProperty("User_name") ||
          !excelData[0].hasOwnProperty("Phone_number") ||
          !excelData[0].hasOwnProperty("Email_address")
        ) {
          return notification.error({
            message: "please enter proper field name",
          });
        }
        const validate = excelData.every((excel) => {
          if (get(excel, "User_name", "") && get(excel, "Phone_number", ""))
            return true;
          if (!get(excel, "User_name", "")) errData.push("user name");
          if (!get(excel, "Phone_number", "")) errData.push("phone number");
          if (!get(excel, "Email_address", "")) errData.push("email address");
          return false;
        });
        setValidateMessage("");
        setCustomValidate("success");
        if (!validate) {
          return notification.error({
            message: `please check the ${errData.join(",")} field(s)`,
          });
        }
      }
      if (!fieldValuesCheck(targetUser, form)) {
        return throwErrors(targetUser, form);
      }
      if (
        form.getFieldValue(["campaign_tags"]) === "filter_users_by" &&
        isEmpty(form.getFieldValue("filterUserBy"))
      ) {
        setValidateMessage("Audience is required");
        return setCustomValidate("error");
      }
      if (
        !form.getFieldValue(["selected_customers"]) &&
        isEmpty(excelData) &&
        !fileList.length
      ) {
        setValidateMessage("Audience is required");
        return setCustomValidate("error");
      }
      if (
        form.getFieldValue(["campaign_tags"]) === "board_cast" &&
        isEmpty(form.getFieldValue("boardCast"))
      ) {
        setValidateMessage("BroadCast is required");
        return setCustomValidate("error");
      }
      if (isEmpty(users)) {
        return notification.error({
          message: `User is empty!,Please create a new user`,
        });
      }
      updateStepsValue({ onlyValidation });
      setSelectCampaign(form.getFieldValue("campaign_type"));
    }
  };
  const handleSelectedUser = (value) => {
    setSelectedUser(value.length || 0);
  };
  const onFinish = () => {
    let wtParams = [];
    if (templateExpressionCount) {
      range(templateExpressionCount).map((index) => {
        const value = form.getFieldsValue([`Content${index + 1}`]);
        if (!isEmpty(value[`Content${index + 1}`])) {
          return wtParams.push(
            encodeURIComponent(value[`Content${index + 1}`])
          );
        } else {
          return (wtParams = []);
        }
      });
    }
    if (selectCampaign === "Whatsapp" && isEmpty(wtParams)) {
      return notification.error({
        message: "Please enter content value",
      });
    }
    // if (stepsValue === 2) {
    //   if (!fieldValuesCheck(ScheduleFields, form)) {
    //     return throwErrors(ScheduleFields, form);
    //   }
    // }
    setLoading(true);
    const filterUserBy = form.getFieldValue("filterUserBy");
    const fields = {
      ...form.getFieldsValue([
        "campaign_name",
        "whatsappTemplate",
        "selected_audience",
        "campaign_type",
        "campaign_tags",
      ]),
    };
    if (!isEmpty(excelData)) {
      fields.excelData = [...excelData];
    }
    fields[selectCampaign] =
      selectCampaign !== "Whatsapp"
        ? { ...form.getFieldsValue([...finalValues[selectCampaign]]) }
        : "";
    fields.app_id = appID;
    fields.apiUrl = apiUrl;
    fields.appKey = appKey;
    fields.appName = appName;
    fields.paymentType = paymentType || "Wallet";
    fields.cost = Number(selectedUser) * Number(costing);
    fields.tenantId = tenantId;
    if (fields.campaign_type === "Whatsapp") {
      fields.Whatsapp = wtParams ? wtParams.toString() : "";
    }
    if (fields.campaign_tags === "filter_users_by") {
      fields.filterUserBy = filterUserBy ? compact(filterUserBy) : [];
    }
    if (fields.campaign_tags === "board_cast") {
      const selectBroadCast = form.getFieldValue("boardCast");
      const filterData = broadCast.filter((data) =>
        selectBroadCast.includes(data.board_cast_uid)
      );
      const getUsers = filterData.map((item) => item.user_list);
      const uniqByMobile = uniqBy(getUsers, "phone_number");
      const mobileNum = flatten(uniqByMobile).map((item) => item.phone_number);
      fields.filterUserBy = mobileNum ? compact(mobileNum) : [];
    }
    myApi.endpoints.campaign
      .create(fields, {}, "/publish-campaign")
      .then((res) => {
        const response = get(res, "data", {});
        if (response.success) {
          notification.success({ message: "Message sent successfully" });
          setLoading(false);
          history.push("/campaign/all-campaigns");
          form.resetFields();
        } else {
          notification.error({
            message: get(response,'message', "failed to send message"),
          });
          setLoading(false);
        }
      })
      .catch((err) => {
        notification.error({
          message: get(err, "message", "failed to send message"),
        });
        setLoading(false);
      });
  };

  const options = {
    Email: (
      <EmailCompaign form={form} next={next} selectCampaign={selectCampaign} />
    ),
    Push: (
      <PushCampaign form={form} next={next} selectCampaign={selectCampaign} />
    ),
    SMS: (
      <SmsCampaign form={form} next={next} selectCampaign={selectCampaign} />
    ),
    Whatsapp: (
      <WhatsappCampaign
        form={form}
        next={next}
        selectCampaign={selectCampaign}
        getExpressionCount={getExpressionCount}
        users={users}
        whatsappTemplateData={whatsappTemplateData}
        loading={loading}
        templateExpressionCount={templateExpressionCount}
        dupTemplateObj={dupTemplateObj}
        setDupTemplateObj={setDupTemplateObj}
        dupWtTemp={dupWtTemp}
        setDupWtTemp={setDupWtTemp}
        broadCast={broadCast}
        costing={costing}
        onFinish={onFinish}
        walletBalance={walletBalance}
        walletBalanceError={walletBalanceError}
        handleSelectedUser={handleSelectedUser}
      />
    ),
  };

  const steps = [
    {
      title: "Target users",
      render: (
        <TargetUsers
          form={form}
          excelData={excelData}
          setExcelData={setExcelData}
          setFileList={setFileList}
          fileList={fileList}
          customValidate={customValidate}
          setCustomValidate={setCustomValidate}
          validateMessage={validateMessage}
          setValidateMessage={setValidateMessage}
          users={users}
          fetchUser={fetchUser}
          broadCast={broadCast}
        />
      ),
    },
    {
      title: "Preview & Publish",
      render: options[selectCampaign],
    },
  ];

  const prev = () => {
    setStepsValue(stepsValue - 1);
  };

  return (
    <Spin spinning={loading}>
      <Form layout="vertical" form={form}>
        <div className="search-container">
          <div>
            <Breadcrumb separator=">">
              <Breadcrumb.Item>
                <HomeOutlined />
              </Breadcrumb.Item>
              <Breadcrumb.Item>Campaign</Breadcrumb.Item>
              <Breadcrumb.Item>{selectCampaign}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
        <div className="box box_campaign">
          <div className="box__content p-0">
            <Steps current={stepsValue} style={{ marginBottom: 50 }}>
              {steps.map((item) => (
                <Step key={item.title} title={item.title} />
              ))}
            </Steps>
            {steps[stepsValue].render}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "10px",
          }}
        >
          {stepsValue > 0 && (
            <Button style={{ margin: "0 8px" }} onClick={() => prev()}>
              Previous
            </Button>
          )}
          {stepsValue < steps.length - 1 && (
            <Button
              type="primary"
              onClick={() => next({ onlyValidation: false })}
            >
              Next
            </Button>
          )}
          {stepsValue === steps.length - 1 && (
            <Form.Item>
              <Button
                htmlType="submit"
                type="primary"
                disabled={!whatsappTemplate || !isEmpty(walletBalanceError)}
                onClick={() => onFinish()}
              >
                {Number(costing)
                  ? `Pay : ₹ ${parseFloat(
                      Number(selectedUser || 0) * Number(costing)
                    ).toFixed(2)} & Publish`
                  : `Publish`}
              </Button>
            </Form.Item>
          )}
        </div>
      </Form>
    </Spin>
  );
};

export default CampaignTab;
